import { render, staticRenderFns } from "./MCQSubject.vue?vue&type=template&id=62789ef0&"
import script from "./MCQSubject.vue?vue&type=script&lang=ts&"
export * from "./MCQSubject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports